const getters = {
    files: (state) => state.files,
    fileId: (state) => state.fileId,
    loading: state => state.loading
};

export default getters;